import styled from 'styled-components';

export const ImageContainer = styled.div`
  position: relative;
  display: inline-block;
  overflow: hidden;
  &.image-preview {
    max-width: 300px;
    max-height: 300px;
    width: auto;
    height: auto;
    border-radius: 8px !important;
  }
  &.figma-image img {
    max-width: 100%;
    width: auto;
    max-height: 419px;
    height: auto;
    border-top: unset;
    border-bottom: unset;
    border-radius: 0px !important;
  }
  &.print-screen-image img {
    max-width: 300px;
    max-height: 300px;
    width: auto;
    height: auto;
  }
  &:hover .ant-image-mask {
    opacity: 1;
  }
`;

export const StyledImage = styled.img`
  max-width: 300px;
  max-height: 300px;
  width: auto;
  height: auto;
  cursor: pointer;
  object-fit: contain;
  @media (max-width: 449px) {
    width: auto;
    max-width: 100%;
  }
`;

export const PreviewWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.45);
`;

export const PreviewHeader = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  gap: 24px;
  border-radius: 8px;
  z-index: 1001;
`;

export const PreviewActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const ActionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 11px;
  background: var(--background-overlay);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: var(--background-thumb-overlay);
  }

  svg {
    fill: none;
  }
`;

export const CloseButton = styled(ActionButton)`
  margin-left: auto;
`;

export const Divider = styled.div`
  width: 1px;
  height: 32px;
  background-color: var(--border-secondary);
`;

export const PreviewImage = styled.img<{ zoom: number; rotation: number; flipH: boolean; flipV: boolean }>`
  max-width: 100% !important;
  max-height: 70%;
  width: auto !important;
  height: auto !important;
  object-fit: contain;
  transform: scale(${(props) => props.zoom}) rotate(${(props) => props.rotation}deg)
    scaleX(${(props) => (props.flipH ? -1 : 1)}) scaleY(${(props) => (props.flipV ? -1 : 1)});
  transition: transform 0.3s ease;
`;

export const ScreenshotToolbar = styled.div`
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  padding: 6px;
  background: var(--background-overlay);
  border-radius: 50px;
  backdrop-filter: blur(8px);
  z-index: 1001;
  @media (max-width: 449px) {
    bottom: 82px;
  }
`;

export const ToolbarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ToolbarButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: var(--text-primary);
  transition: background-color 0.2s;
  border-radius: 50%;
  &:hover {
    background: var(--background-thumb-overlay);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ToolbarDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: var(--border-secondary);
`;

export const ToolbarInput = styled.input`
  background: var(--background-thumb-overlay);
  border: 1px solid var(--border-secondary);
  border-radius: 4px;
  padding: 6px 12px;
  color: var(--text-primary);
  font-size: 14px;
  width: 200px;

  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

export const ZoomControls = styled.div`
  position: absolute;
  right: 24px;
  bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1001;
`;

export const ZoomButton = styled(ActionButton)`
  background: var(--background-overlay);
  padding: 8px;
  border-radius: 4px;

  &:hover {
    background: var(--background-thumb-overlay);
  }
`;

export const ImageDiv = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 100% !important;
    max-height: 70% !important;
    vertical-align: middle;
    cursor: grab;
    user-select: none;
  }
`;

export const ImageMask = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;

  .zoom-icon {
    font-size: 24px;
    color: #fff;
  }
`;
